export const metaColetivaFilterFields = [
  {
    name: "lojaId",
    label: "Loja",
    type: "select" as const,
    placeholder: "Selecione uma loja",
    options: [],
  },
  {
    name: "dataInicio",
    label: "Data Início",
    type: "date" as const,
    placeholder: "Selecione a data de início",
  },
  {
    name: "dataFim",
    label: "Data Fim",
    type: "date" as const,
    placeholder: "Selecione a data de fim",
  },
];
